var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"ideal-bank-element"}}),_c('br'),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.submit()}}},[_vm._v(" Betalen ")])])}
var staticRenderFns = []

export { render, staticRenderFns }